import { Box, Image, Text } from "@chakra-ui/react";

interface AcceptTermsAndCondsProps {
  onOpenTdC: () => void;
}

export const AcceptTermsAndConds = (props: AcceptTermsAndCondsProps) => {
  const { onOpenTdC } = props;
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      w={"100%"}
      h={"100%"}
      backgroundColor={"#FFF1EB"}
      bgImage={process.env.PUBLIC_URL + "/assets/images/texture-ultafetti.png"}
      bgSize={"60rem"}
      px="2rem"
      gap={{ base: "1.375rem", md: "3.125rem" }}
    >
      <Image
        mt={{ base: "1.5rem", md: "2.125rem" }}
        mb={{ base: "0.625rem", md: "0.875rem" }}
        src={process.env.PUBLIC_URL + "/assets/images/Exclamation-triangle.svg"}
        width={{ base: "2.8125rem", md: "68px" }}
        height={{ base: "2.8125rem", md: "68px" }}
      />
      <Text
        color="#000000"
        fontSize={{ base: "1rem", md: "1.5925rem" }}
        fontFamily={"Circular"}
        fontWeight="500"
        letterSpacing={{ base: "0.0262rem", md: "0.04rem" }}
        lineHeight={{ base: "1.475rem", md: "2.2106rem" }}
        textAlign={"center"}
        px={{ base: "5rem", md: "7.5rem" }}
      >
        To use the hair try-on you need to accept the Terms & Conditions
      </Text>
      <Box
        color="#000000"
        cursor="pointer"
        borderBottom="0.0625rem solid #000000"
      >
        <Text
          fontFamily={"Circular"}
          fontSize={{ base: "0.75rem", md: "1.1238rem" }}
          fontWeight="300"
          letterSpacing={{ base: "0.0187rem", md: "0.0281rem" }}
          lineHeight={{ base: "1rem", md: "1.4988rem" }}
          textAlign={"center"}
          onClick={onOpenTdC}
        >
          View Terms & Conditions
        </Text>
      </Box>
    </Box>
  );
};
